(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["selvaman-home"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var hotFilter = event.target.closest('[data-selvaman-hot-filter]');
    if (hotFilter) {
      var hot = hotFilter.closest('[data-selvaman-hot]');
      if (!hot) return;

      var filter = hotFilter.getAttribute('data-selvaman-hot-filter');
      var hotButtons = hot.querySelectorAll('[data-selvaman-hot-filter]');
      var hotCards = hot.querySelectorAll('[data-selvaman-hot-card]');

      hotButtons.forEach(function (button) {
        var isActive = button === hotFilter;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      hotCards.forEach(function (card) {
        var matches = filter === 'all' || card.getAttribute('data-hot-group') === filter;
        card.hidden = !matches;
      });

      var hotRail = hot.querySelector('[data-selvaman-hot-rail]');
      if (hotRail) hotRail.scrollTo({ left: 0, behavior: 'smooth' });
      return;
    }

    var hotScroll = event.target.closest('[data-selvaman-hot-scroll]');
    if (hotScroll) {
      var hotSection = hotScroll.closest('[data-selvaman-hot]');
      var rail = hotSection && hotSection.querySelector('[data-selvaman-hot-rail]');
      if (!rail) return;

      var direction = hotScroll.getAttribute('data-selvaman-hot-scroll') === 'next' ? 1 : -1;
      rail.scrollBy({ left: direction * rail.clientWidth * 0.9, behavior: 'smooth' });
      return;
    }

    var reviewsScroll = event.target.closest('[data-selvaman-reviews-scroll]');
    if (reviewsScroll) {
      var reviews = reviewsScroll.closest('[data-selvaman-reviews]');
      var reviewsRail = reviews && reviews.querySelector('[data-selvaman-reviews-rail]');
      if (!reviewsRail) return;

      var reviewsDirection = reviewsScroll.getAttribute('data-selvaman-reviews-scroll') === 'next' ? 1 : -1;
      reviewsRail.scrollBy({ left: reviewsDirection * reviewsRail.clientWidth * 0.9, behavior: 'smooth' });
      return;
    }

    var trigger = event.target.closest('[data-selvaman-filter]');
    if (!trigger) return;

    var lineup = trigger.closest('[data-selvaman-lineup]');
    if (!lineup) return;

    var filter = trigger.getAttribute('data-selvaman-filter');
    var buttons = lineup.querySelectorAll('[data-selvaman-filter]');
    var cards = lineup.querySelectorAll('[data-selvaman-card]');

    buttons.forEach(function (button) {
      var isActive = button === trigger;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    cards.forEach(function (card) {
      var matches = filter === 'all' || card.getAttribute('data-strength') === filter;
      card.hidden = !matches;
    });
  });

  document.querySelectorAll('[data-selvaman-reviews]').forEach(function (reviews) {
    var rail = reviews.querySelector('[data-selvaman-reviews-rail]');
    var progress = reviews.querySelector('[data-selvaman-reviews-progress]');
    if (!rail || !progress) return;

    var updateProgress = function () {
      var max = rail.scrollWidth - rail.clientWidth;
      var visibleRatio = rail.scrollWidth > 0 ? rail.clientWidth / rail.scrollWidth : 1;
      var widthRatio = Math.max(visibleRatio, 0.18);
      var offsetRatio = max > 0 ? rail.scrollLeft / max : 0;
      progress.style.width = widthRatio * 100 + '%';
      progress.style.transform = 'translateX(' + offsetRatio * (100 / widthRatio - 100) + '%)';
    };

    updateProgress();
    rail.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["selvaman-product-pdp"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initGallery = (gallery) => {
      if (!gallery || gallery.dataset.galleryBound === 'true') return;

      const slides = Array.from(gallery.querySelectorAll('.selvaman-pdp-gallery__slide'));
      const thumbs = Array.from(gallery.querySelectorAll('.selvaman-pdp-gallery__thumb'));
      const dots = Array.from(gallery.querySelectorAll('[data-media-dot]'));

      if (!slides.length || !thumbs.length) return;

      gallery.dataset.galleryBound = 'true';

      const setActiveMedia = (mediaId) => {
        slides.forEach((slide) => {
          slide.classList.toggle('hidden', slide.dataset.mediaId !== mediaId);
        });

        thumbs.forEach((thumb) => {
          const isActive = thumb.dataset.mediaTarget === mediaId;
          thumb.classList.toggle('is-active', isActive);
          thumb.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        dots.forEach((dot) => {
          dot.classList.toggle('is-active', dot.dataset.mediaDot === mediaId);
        });

        gallery.dataset.selectedMediaId = mediaId;
      };

      gallery.addEventListener('click', (event) => {
        const thumb = event.target.closest('.selvaman-pdp-gallery__thumb');
        if (!thumb || !gallery.contains(thumb)) return;
        setActiveMedia(thumb.dataset.mediaTarget);
      });

      setActiveMedia(gallery.dataset.selectedMediaId || thumbs[0].dataset.mediaTarget);

      document.addEventListener('variant:change', (event) => {
        const variantMediaId = event.detail?.variant?.featured_media?.id;
        if (variantMediaId) {
          setActiveMedia(String(variantMediaId));
        }
      });
    };

    const initAllGalleries = (root = document) => {
      root.querySelectorAll('.selvaman-pdp-gallery').forEach(initGallery);
    };

    const initQuantityControls = (root = document) => {
      root.querySelectorAll('.selvaman-pdp-form__quantity').forEach((quantity) => {
        if (quantity.dataset.quantityBound === 'true') return;
        quantity.dataset.quantityBound = 'true';

        const input = quantity.querySelector('input[name="quantity"]');
        const decrement = quantity.querySelector('[data-quantity-decrement]');
        const increment = quantity.querySelector('[data-quantity-increment]');
        if (!input || !decrement || !increment) return;

        decrement.addEventListener('click', () => {
          const nextValue = Math.max(Number(input.min || 1), Number(input.value || 1) - 1);
          input.value = nextValue;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });

        increment.addEventListener('click', () => {
          input.value = Number(input.value || 1) + 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initAllGalleries();
        initQuantityControls();
      }, { once: true });
    } else {
      initAllGalleries();
      initQuantityControls();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAllGalleries(event.target);
      initQuantityControls(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
